import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { CSS_CLASSES } from '../../../css-classes';
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Slider from "react-slick";
import LableIconNav from './reusable-nav-component/LableIconNav';
import OnlyLableNav from './reusable-nav-component/OnlyLableNav';
import HoverNav from './hover/HoverNav';

const NavCarousel = (props) => {
    const token = window.localStorage.getItem("user_token");
    // Consolidate selectors into one
    const { playerMenu, componentSetting } = useSelector(state => ({
        playerMenu: state.menuListR.data,
        componentSetting: state.componentSettingListR.data,
    }));

    const [isItem, setIsItem] = useState();
    const [loggedIn, setLoggedIn] = useState('');
    const [hovered, setHovered] = useState(false);

    const handleMouseOver = useCallback((code) => setIsItem(code), []);
    const handleOver = useCallback(() => setHovered(true), []);
    const handleOut = useCallback(() => setHovered(false), []);

    useEffect(() => {
        setLoggedIn(token);
    }, [token]);

    const menuList = useMemo(() => {
        if (!playerMenu) return {};
        const menuArray = loggedIn ? playerMenu.after : playerMenu.before;
        const sortedMenuObject = Object.values(menuArray || {}).sort((a, b) => parseInt(a.order) - parseInt(b.order))
            .reduce((acc, item) => {
                acc[item.code] = item;
                return acc;
            }, {});
        return sortedMenuObject;
    }, [loggedIn, playerMenu]);

    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
    };

    return (
        <>
            {Object.keys(menuList).length > 0 && (
                <div className='navbar-main-carousel'>
                    <div className={hovered ? 'hover pos-r' : 'pos-r'} onMouseOver={handleOver} onMouseLeave={handleOut}>
                        <div className="container">
                            <div className={componentSetting?.["horizonatal-nav-bar"]?.["default-value"]}>
                                <Slider {...settings} className={CSS_CLASSES.navbar}>
                                    {Object.values(menuList).map((v, i) => {
                                        if (v.footer_menu || (v.location !== "menu" && v.location !== "sub_menu") || !v.status || v.code === 'live-chat') {
                                            return null;
                                        }

                                        const customLink = v.code === 'home' ? '' : (v.code === 'my-referral' ? 'referral' : v.code);
                                        const NavComponent = componentSetting?.["horizonatal-nav-bar"]?.["default-value"] === "label-icon"
                                            ? LableIconNav
                                            : OnlyLableNav;

                                        return (
                                            <React.Fragment key={i}>
                                                <NavComponent
                                                    t={props.t}
                                                    i={i}
                                                    v={v}
                                                    menuList={menuList}
                                                    ftpPath={playerMenu?.ftp_path}
                                                    mouseOver={handleMouseOver}
                                                    customLink={customLink}
                                                />
                                            </React.Fragment>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <HoverNav code={isItem} />
        </>
    );
};

NavCarousel.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(NavCarousel);
